import { Container } from "./MetricsSection.styles";
import { MetricCard } from "./MetricCard";
import { ReactComponent as EuroIcon } from "assets/icons/metrics/euro_icon.svg";
import { ReactComponent as SubscribersIcon } from "assets/icons/metrics/mail_icon.svg";
import { ReactComponent as OrdersIcon } from "assets/icons/metrics/shopping_cart_icon.svg";
import { useUpliftMetrics } from "../../hooks";

export const MetricsSection = () => {
  const { data, loading } = useUpliftMetrics();

  if (loading) {
    return null;
  }

  return (
    <Container>
      <MetricCard
        translationKey="dashboardModule.metrics.revenue.title"
        value={data?.revenue ?? 0}
        Icon={EuroIcon}
      />
      <MetricCard
        translationKey="dashboardModule.metrics.orders.title"
        value={data?.orders ?? 0}
        Icon={OrdersIcon}
      />
      <MetricCard
        translationKey="dashboardModule.metrics.subscribers.title"
        value={data?.subscribers ?? 0}
        Icon={SubscribersIcon}
      />
    </Container>
  );
};
